
export enum RegistratinEntityType {
    Cotista = 'Cotista',
    Cedente = 'Cedente',
    Sacado = 'Sacado'
}
